import React, { FunctionComponent, ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import WithMenu from '@hoc/WithMenu/WithMenu'

import Markdown from '@components/Markdown/Markdown'

import gotchiShadow from '@assets/images/characters/gotchi-shadow.png'
import gotchiQuestion from '@assets/images/characters/gotchi-question.png'
import '@assets/images/characters/gotchi.png'
import './MarkdownPage.scss'

interface Props {
  contentSlug?: string
}

export const MarkdownPage: FunctionComponent<Props> = ({ contentSlug }: Props): ReactElement => {
  const { t } = useTranslation('MarkdownPage')
  const headerMarkdown = t(`${contentSlug}.headerMarkdown`, { defaultValue: null })
  return (
    <div className={`MarkdownPage MarkdownPage-${contentSlug}`}>
      <a className="MarkdownPage-Image" href="/">
        <img src={contentSlug === 'about' ? gotchiQuestion : gotchiShadow} alt={contentSlug} />
      </a>
      {headerMarkdown && <Markdown content={headerMarkdown} className="MarkdownPage-header" />}
      <Markdown content={t(`${contentSlug}.markdown`)} isArialFontFamily/>
    </div>
  )
}

export default WithMenu(MarkdownPage)
